if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.isStickyAtc = !!this.closest('.FixedAtcWrapper');
        this.viewCartMode = false;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (this.isStickyAtc && this.viewCartMode) {
          const cartDrawer = this.cart?.tagName === 'CART-DRAWER' ? this.cart : document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open(this.submitButton);
          }
          return;
        }

        const isQuickCart = !!this.closest('#sideDrawer');
        if (isQuickCart) {
          const variantInput = this.form.querySelector('[name="id"]');
          const qtyInput = this.form.querySelector('.customquantityform');
          const selectedVariant = document.querySelector('#sideDrawer .Variantbutton input[name="colorOptions"]:checked');
          const qtyField = document.querySelector('#sideDrawer #number');

          if (!selectedVariant?.id) {
            this.handleErrorMessage('Please select a size');
            return;
          }

          variantInput.value = selectedVariant.id;
          if (qtyInput && qtyField) qtyInput.value = qtyField.value || '1';
        }

        this.handleErrorMessage();
        this.error = false;
        this.quickCartAdded = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const sectionIds = this.getSectionsToRender();
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
        if (this.cart) this.cart.setActiveElement(document.activeElement);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.error = true;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              return;
            }

            this.quickCartAdded = isQuickCart;
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.renderCartSections(response);
            this.setStickyViewCartState();

            if (!this.cart) return;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            this.error = true;
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            if (this.quickCartAdded && !this.error) {
              if (typeof showProductPopup === 'function') {
                showProductPopup();
              }
            }
          });
      }

      setStickyViewCartState() {
        if (!this.isStickyAtc || !this.submitButtonText) return;

        this.viewCartMode = true;
        this.submitButton.dataset.viewCart = 'true';
        this.submitButtonText.textContent =
          window.quickOrderListStrings?.viewCart || window.variantStrings?.viewCart || 'View cart';

        const liveRegion = this.querySelector('[id^="atc-status-live-region-"]');
        if (liveRegion) liveRegion.textContent = this.submitButtonText.textContent;
      }

      resetStickyViewCartState() {
        if (!this.isStickyAtc) return;

        this.viewCartMode = false;
        this.submitButton.removeAttribute('data-view-cart');
        if (this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      getSectionsToRender() {
        const sectionIds = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
        if (!sectionIds.includes('cart-icon-bubble')) sectionIds.push('cart-icon-bubble');
        return sectionIds;
      }

      renderCartSections(response) {
        const bubbleHtml = response?.sections?.['cart-icon-bubble'];
        if (!bubbleHtml) return;

        const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        const sectionContent = parsed.querySelector('.shopify-section');
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon && sectionContent) cartIcon.innerHTML = sectionContent.innerHTML;

        if (typeof updateMobileCartCount === 'function') updateMobileCartCount();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
